import { theme } from "../../theme";

export const BUTTON_SIZE = 50;
export const CONTROLS_HEIGHT = BUTTON_SIZE + theme.gridSize;
export const BORDER_WIDTH = 2;
export const BACK_COLOR = "#121212";
